import { Box, InputAdornment } from '@mui/material';
import { clsx } from 'clsx';
import styles from './MaskedTextField.module.scss';
import { useMemoizedDataIds } from '../../shared/utils/dataId';
import { Tooltip } from '../../tooltip/Tooltip';
import { TextField, TextFieldProps } from '../TextField/TextField';
import { LinkButton } from '../../link/LinkButton';
import { getMaskedString } from '../../shared/utils/string/formatter';
import { MASKED_TEXT_FIELD_DATA_IDS } from './maskedTextFieldDataId';

export type MaskedTextFieldProps = TextFieldProps & {
  onChangeClick: VoidFunction;
};

export function MaskedTextField({ dataId, value, onChangeClick, ...props }: MaskedTextFieldProps) {
  const dataIds = useMemoizedDataIds(MASKED_TEXT_FIELD_DATA_IDS, dataId);

  return (
    <Box className={styles.maskWrapper} data-id={dataIds.container}>
      <Tooltip
        dataId={dataIds.labelTooltip}
        placement='bottom-start'
        title={(value || '') as string}
        enableOnTextOverflow
      >
        <span data-id={dataIds.label} className={clsx(styles.maskLabel, 'text-medium')}>
          {getMaskedString(value as string)}
        </span>
      </Tooltip>

      <TextField
        {...props}
        defaultValue='&nbsp;'
        dataId={dataIds.textField}
        InputProps={{
          ...props.InputProps,
          readOnly: true,
          inputProps: {
            ...props.InputProps?.inputProps,
            readOnly: true
          },
          endAdornment: !props.disabled ? (
            <InputAdornment
              data-id={dataIds.adornment}
              position='end'
              className={styles.maskAction}
            >
              <LinkButton tag='button' onClick={onChangeClick} dataId={dataIds.clearBtn}>
                Change
              </LinkButton>
            </InputAdornment>
          ) : null
        }}
      />
    </Box>
  );
}
